import { useMemo } from 'react';

import { shortenTransactionHash } from '../utils/helpers';

export const useShortHash = (txHash: string | undefined) => {
  return useMemo(() => shortenTransactionHash(txHash ?? ''), [txHash]);
};
